import { EuiButtonEmpty } from "@inscopix/ideas-eui";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { DataTableRowData } from "../DataTable";
import { GridApi } from "ag-grid-community";

export interface QuickActionGoToResultsProps {
  gridApi: GridApi<DataTableRowData> | undefined;
  tableId: string;
}
export const QuickActionGoToResults = ({
  gridApi,
  tableId,
}: QuickActionGoToResultsProps) => {
  const resultColumnIds = useDataTableContext((s) => {
    const table = s.tables.find(({ id }) => id === tableId);
    const columns = table?.columns.filter((column) => column.is_result);
    return columns?.map((column) => column.id) ?? [];
  });

  const handleClick = () => {
    if (resultColumnIds.length > 0 && gridApi !== undefined) {
      gridApi.ensureColumnVisible(resultColumnIds[0], "start");
      // https://github.com/ag-grid/ag-grid/issues/5085
      setTimeout(() => {
        gridApi?.flashCells({ columns: resultColumnIds });
      }, 0);
    }
  };

  return (
    <EuiButtonEmpty
      size="xs"
      color="success"
      iconType="arrowEnd"
      iconSide="right"
      onClick={handleClick}
      disabled={resultColumnIds.length === 0}
    >
      Go to results
    </EuiButtonEmpty>
  );
};
